export default __webpack_public_path__ + "static/media/groom.da8a88b0.jpg";